
import { computed, defineComponent, Ref, ref } from 'vue'

import useAccount from '@/common/composable/useAccount'
import { LINKS } from '@/router/links'

export default defineComponent({
    props: {
        isOpened: {
            type: Boolean,
            default: true,
        },
    },
    emits: ['toggle'],
    setup(props, { emit }) {
        const { havePermissions } = useAccount()

        let displayed_links = LINKS.filter((link) => havePermissions(link.permissions)).map(
            (link) => {
                return {
                    ...link,
                    sub_links: link.sub_links.filter((sub_link) =>
                        havePermissions(sub_link.permissions)
                    ),
                }
            }
        )
        displayed_links = displayed_links.filter(
            (link) =>
                (link.not_permissions && !havePermissions(link.not_permissions)) ||
                !link.not_permissions
        )

        const opened_parent: Ref<number | null> = ref(null)

        const openParent = (id: number) => {
            if (opened_parent.value === id) {
                opened_parent.value = null
                return
            }

            opened_parent.value = id
        }

        const toggleMenu = () => {
            emit('toggle')
        }

        const isProdVersion = computed(() => window.location.href.includes('bpms.spark.kz'))
        const getLogoClass = computed(() => {
            let result = ''

            if (isProdVersion.value) result += 'Sidebar__logo'
            else result += 'Sidebar__logo-dev'

            if (!props.isOpened) result += ' justify-center'
            else result += ' justify-between'

            return result
        })
        const getLogoText = computed(() => (isProdVersion.value ? 'SPARK BPMS' : 'SPARK BPMS DEV'))

        return {
            displayed_links,
            opened_parent,
            openParent,
            toggleMenu,
            getLogoClass,
            getLogoText,
        }
    },
})
